import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { userService } from '../services/userService';
import { useUser } from '../contexts/UserContext';
import { secureLocalStorage } from '../utils/crypto';
import { FirstAccessGuard } from '@/Components/Guards/FirstAccessGuard';
import QuizModal from '@/Components/Modals/QuizModal';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, fetchUser } = useUser();
  const location = useLocation();
  
  useEffect(() => {
    const checkAndFetchUser = async () => {
      if (!user && !loading && userService.isAuthenticated()) {
        try {
          await userService.checkTokenExpiration();
          
          const token = secureLocalStorage.getItem('idToken') || secureLocalStorage.getItem('token');
          if (token) {
            await fetchUser(token);
          }
        } catch (error) {
          console.error('Erro ao verificar autenticação:', error);
        }
      }
    };
    
    checkAndFetchUser();
  }, [user, loading, fetchUser]);
  
  if (loading) {
    return <div>Carregando...</div>;
  }
  
  if (!userService.isAuthenticated()) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }
  
  return (
    <FirstAccessGuard>
      <QuizModal />
      {children}
    </FirstAccessGuard>
  );
}; 
